module.exports = __webpack_public_path__ + "img/zurich.6196fe1e.png";